import { Settings, ShieldCheck, Mail, Cpu } from "lucide-react";
import { PageHeader, Card, SectionTitle } from "@/components/common/PageHeader";

const ITEMS = [
  { icon: ShieldCheck, title: "Authentication & Roles", desc: "Email/password + Emergent Google sign-in. Roles: platform admin and customer. Registration cannot self-assign admin.", state: "Active" },
  { icon: Mail, title: "Transactional Email (Resend)", desc: "Welcome emails and AI auto-run digests via Emergent-managed Resend. Sender: Millionaire Mindsetters Technologies.", state: "Connected" },
  { icon: Cpu, title: "AI Model Router", desc: "OpenAI / Claude / Gemini via the capability router. Scheduled agent auto-runs (daily/weekly).", state: "Active" },
  { icon: Settings, title: "Environment", desc: "SANDBOX. Provider adapters (Experian, Plaid, D&B) are labeled PROVIDER APPROVAL PENDING until credentials are connected.", state: "Sandbox" },
];

export default function PlatformSettings() {
  return (
    <div className="space-y-6 animate-fade-up" data-testid="owner-settings-page">
      <PageHeader eyebrow="Governance" title="Platform Settings"
        subtitle="Configuration for the platform. Only truthful, connected capabilities are shown here." />
      <Card className="p-5">
        <SectionTitle icon={Settings}>Configuration</SectionTitle>
        <div className="grid gap-3 sm:grid-cols-2">
          {ITEMS.map((it) => (
            <div key={it.title} className="rounded-xl border border-slate-200 bg-white p-4">
              <div className="flex items-center justify-between">
                <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#1a5fd0]/10 text-[#1a5fd0]"><it.icon size={18} /></span>
                <span className="rounded-full bg-slate-100 px-2 py-0.5 font-mono text-[9px] font-bold uppercase text-slate-500">{it.state}</span>
              </div>
              <div className="mt-2.5 font-head text-[14px] font-bold text-slate-900">{it.title}</div>
              <p className="mt-1 text-[12px] text-slate-500">{it.desc}</p>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );
}
